import { render } from "./login-new-user.vue?vue&type=template&id=1b1aa402&scoped=true"
import script from "./login-new-user.vue?vue&type=script&lang=js"
export * from "./login-new-user.vue?vue&type=script&lang=js"

import "./login-new-user.vue?vue&type=style&index=0&id=1b1aa402&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b1aa402"]])

export default __exports__